<template>
  <div class="auth" ref="auth">
    <router-view />
  </div>
</template>

<script>

import { mapMutations } from 'vuex';

export default {
  name: "AuthLayout",
  data() {
    return {
      span: 8,
    };
  },
  methods: {
    ...mapMutations(['offAppLoader']),
    editSpan() {
      setTimeout(() => {
        if (this.$refs.auth) {
          if (this.$refs.auth.querySelector(".form")) {
            this.$refs.auth.querySelector(".form").classList.add("show");
          }
        }
      }, 0);
    },
  },
  mounted() {
    document.head.querySelector("[name~=theme-color][content]").content = '#fff'
    document.head.querySelector("[name~=viewport][content]").content = 'width=device-width,initial-scale=1.0'
    document.querySelector('body').classList.add('responsive')
    this.editSpan();
  },
  created() {
    window.addEventListener("resize", this.editSpan);
  },
};
</script>

<style lang="scss">
.auth_loader {
  display: flex !important;
  left: 0 !important;
  transform: translateX(0) !important;
  margin: 15% auto !important;
}
</style>
